var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var TabTable = (function (_super) {
    __extends(TabTable, _super);
    function TabTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabTable.prototype.handleSelectionChange = function (val) {
        var selectionArr = [];
        val.forEach(function (el) {
            selectionArr.push(el);
        });
        this.$emit('commitSelection', selectionArr);
    };
    TabTable.prototype.handleSizeChange = function (val) {
        this.$emit('handleSizeChange', val);
    };
    TabTable.prototype.handleCurrentChange = function (val) {
        this.$emit('handleCurrentChange', val);
    };
    TabTable.prototype.selectionChange = function (rows, row) {
        this.$emit('selectChange', rows, row);
    };
    TabTable.prototype.selectAll = function (rows) {
        this.$emit('selectChange', rows, null, true);
    };
    __decorate([
        Prop({
            required: true,
            type: Object,
        })
    ], TabTable.prototype, "pager", void 0);
    __decorate([
        Prop({
            required: true,
            type: Boolean,
        })
    ], TabTable.prototype, "showSelection", void 0);
    __decorate([
        Prop({
            required: true,
            type: Boolean
        })
    ], TabTable.prototype, "showIndex", void 0);
    __decorate([
        Prop({
            required: false,
            type: Function
        })
    ], TabTable.prototype, "indexMethod", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], TabTable.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], TabTable.prototype, "tableColumnList", void 0);
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], TabTable.prototype, "dataList", void 0);
    TabTable = __decorate([
        Component
    ], TabTable);
    return TabTable;
}(Vue));
export default TabTable;
